"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumns = void 0;
var React = require("react");
var _1 = require(".");
var TableColumns = function (_a) {
    var children = _a.children;
    var childrenArray = Array.isArray(children) ? children : [children];
    return (React.createElement(_1.TableRow, { isHeader: true }, React.Children.map(childrenArray, function (child, index) {
        return React.cloneElement(child, { ariaColumnIndex: index + 1 });
    })));
};
exports.TableColumns = TableColumns;
